import Base from "./base";
import Gikam from "../core/gikam-core";
import Vue from 'vue';
import Upload from './template/upload/upload';
import jQuery from 'jquery';

let defaultOptions = {
    id: void 0,
    readonly: false,
    renderTo: void 0,
    multiple: true,
    server: void 0,
    deleteUrl: void 0,
    dbTable: void 0,
    bizId: void 0,
    bizCategory: void 0,
    searchUrl: void 0,
    selectFileCategory: false,
    gridSaveService: 'coreFileServiceImpl',
    search: false,
    genericQuery: false,
    accept: void 0,
    onBeforeUpload: Gikam.emptyFunction,
    onBeforeRefresh: Gikam.emptyFunction,
    onGridRowActive: Gikam.emptyFunction,
    gridFilter: true,
    gridPage: true,
    autoClose: false,
    //允许的最大宽度，由父组件传值
    allowWidth: 0,
    fill: false,
    //定制Grid中的列
    formatterGridColumns: (columns) => columns
};

const supportType = [
    {
        code: 'text',
        typeArray: [
            'doc', 'docm', 'docx', 'dot', 'dotm', 'dotx',
            'epub', 'fodt', 'htm', 'html', 'mht', 'odt',
            'ott', 'pdf', 'rtf', 'txt', 'djvu', 'xps'
        ]
    },
    {
        code: 'spreadsheet',
        typeArray: [
            'csv', 'fods', 'ods', 'ots', 'xls', 'xlsm',
            'xlsx', 'xlt', 'xltm', 'xltx'
        ]
    },
    {
        code: 'presentation',
        typeArray: [
            'fodp', 'odp', 'otp', 'pot', 'potm', 'potx',
            'pps', 'ppsm', 'ppsx', 'ppt', 'pptm', 'pptx'
        ]
    }
]

let defaultColumns = [{
    checkbox: true
}, {
    index: true
}, {
    field: 'name',
    title: 'GIKAM.FILE.FILENAME',
    search: true,
    formatter: function (i, v, r) {
        //判断当前文件格式是否被sunwayoffice支持
        let typeStr = '';
        for (let type of supportType) {
            if (type.typeArray.indexOf(r.fileExt) !== -1) typeStr = type.code;
        }

        let officeViewType = Gikam.officeViewType || 'weboffice';
        //如果支持则打开编辑否则为下载文件
        if (typeStr && officeViewType === 'sunwayoffice') {
            let documentParam = `fileType: '${r.fileExt}', fileType: '${r.fileExt}', 
                                 fileId: '${r.id}', fileName: '${r.name}', 
                                 fileUrl: '${r.downloadUrl}', mode: 'edit', 
                                 version: '${r.version || ''}',`;
            return `<a href="javascript:;" onclick="Gikam.editOfficeFile({${documentParam}})">${r.name}</a>`;
        } else {
            return `<a href="javascript:;" onclick="Gikam.printFile('${r.id}', true, null, false, true)">${r.name}</a>`;
        }

    }
}, {
    field: 'createdByName',
    title: 'GIKAM.FILE.CREATEDBYNAME',
    search: true
}, {
    field: 'createdTime',
    title: 'GIKAM.FILE.CREATEDTIME'
}];

export default class Uploader extends Base {

    constructor(options) {
        super(options);
        this.async = [];
        this.listeners = {
            beforeUpload: Gikam.emptyFunction,
            beforeRefresh: Gikam.emptyFunction,
            beforeDelete: Gikam.emptyFunction,
            afterClose: Gikam.emptyFunction,
            uploadSuccess: Gikam.emptyFunction,
            gridRowActive: Gikam.emptyFunction
        };
        this.uploadData = {};
        this.requestData = {};
        this.initialize(options, defaultOptions).init();
    }

    createGrid() {
        let _this = this;
        Gikam.extend(this.requestData, {
            targetId: this.options.dbTable + '$' + this.options.bizId
        });
        if (this.options.bizCategory) {
            this.requestData.bizCategory = this.options.bizCategory
        }
        return Gikam.create('grid', {
            renderTo: this.root,
            url: this.options.bizId ? this.options.searchUrl : null,
            requestData: this.requestData,
            toolbar: this.getGridToolbar(),
            columns: this.getGridColumns(),
            service: this.options.gridSaveService,
            genericQuery: this.options.genericQuery,
            filter: this.options.gridFilter,
            allowWidth: this.options.allowWidth - 20,
            fill: this.options.fill,
            page: false,
            deleteFormatter: row => row.name,
            onBeforeRefresh: function (requestData) {
                _this.trigger('beforeRefresh', requestData);
            },
            onRowActive: function (index, row) {
                _this.trigger('gridRowActive', index, row);
            }
        });
    }


    /**
     * @description 获取表格列
     * @private
     * @returns
     * @memberof Uploader
     */
    getGridColumns() {
        let columns = this.options.formatterGridColumns(Gikam.deepExtend(this.options.columns || defaultColumns));
        this.options.readonly && columns.forEach(function (item) {
            if (Gikam.isNotEmpty(item.editor)) {
                item.editor = false;
            }
        });
        return columns;
    }

    getGridToolbar() {
        let _this = this;
        return this.options.readonly ? [] :
            [{
                type: 'button',
                text: 'GIKAM.FILE.BUTTON.UPLOAD_FILE',
                icon: 'upload',
                onClick: function () {
                    if (_this.options.multiple === false && _this.grid.getData().length > 0) {
                        Gikam.alert('GIKAM.FILE.TIP.UPLOAD_ONE_ONLY');
                        return;
                    }
                    if (!_this.options.bizId || _this.trigger('beforeUpload') === false) return;
                    _this.options.selectFileCategory ? _this.selectFileCategory().done(function () {
                        _this.showUploadModal();
                    }) : _this.showUploadModal();
                }
            }, {
                type: 'button',
                text: 'GIKAM.FILE.BUTTON.DELETE_FILE',
                icon: 'file-remove',
                onClick: function () {
                    if (_this.trigger('beforeDelete') === false) {
                        return;
                    }
                    _this.grid.deleteRows(_this.options.deleteUrl);
                }
            }, ...this.getOtherGridToolbar()];
    }

    getOtherGridToolbar() {
        return [];
    }

    showUploadModal() {
        let _this = this;
        new Vue({
            el: jQuery('<Upload :options="options"></Upload>').appendTo('body')[0],
            components: {
                Upload
            },
            provide: {
                upload: this
            },
            data() {
                return {
                    options: _this.options
                }
            }
        });
    }

    createRoot() {
        this.root = jQuery('<div class="uploader">').css({
            width: '100%',
            height: '100%'
        }).attr('id', this.options.id || '').appendTo(this.options.renderTo)[0];
        this.bindInstance(this.root);
    }

    setRequestData(data) {
        Gikam.extend(this.requestData, data, {
            targetId: this.options.dbTable + '$' + this.options.bizId
        });
        this.grid && this.grid.refresh({
            requestData: this.requestData,
            url: this.options.bizId ? this.options.searchUrl : null
        });
    }

    setOptions(param) {
        Gikam.jQuery.extend(true, this.options, param);
        this.setRequestData(param);
    }

    setUploadData(data) {
        this.uploadData = data;
    }

    setDefaultOptions(options) {
        Gikam.extend(true, defaultOptions, options.defaultOptions);
    }

    init() {
        this.createRoot();
        this.grid = this.createGrid();
    }

}

